import { createActionGroup, emptyProps, props } from '@ngrx/store';

export const productSummaryActions = createActionGroup({
  source: 'Product Summary',
  events: {
    'Stop Currently Active Credits': props<{ vacancyId: string }>(),
    'Stop Currently Active Credits Success': emptyProps(),
    'Stop Currently Active Credits Error': props<{ error: unknown }>(),
  },
});
